var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBeer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.7 11.1044C23.7 11.4853 23.625 11.8624 23.4793 12.2142C23.3335 12.5661 23.1199 12.8858 22.8506 13.1551C22.5813 13.4244 22.2616 13.638 21.9098 13.7837C21.5579 13.9294 21.1808 14.0044 20.8 14.0044H12.8V20.0044C12.8 20.5614 12.5788 21.0955 12.1849 21.4894C11.7911 21.8832 11.257 22.1044 10.7 22.1044C10.143 22.1044 9.60891 21.8832 9.21508 21.4894C8.82125 21.0955 8.6 20.5614 8.6 20.0044V14.0044H6.8C6.0574 14.0044 5.3452 13.7095 4.8201 13.1844C4.295 12.6592 4 11.9471 4 11.2044C4 10.4618 4.295 9.74965 4.8201 9.22455C5.3452 8.69945 6.0574 8.40445 6.8 8.40445C6.99482 6.65211 7.82584 5.03217 9.13552 3.85175C10.4452 2.67134 12.1425 2.01251 13.9056 2.00018C15.6687 1.98785 17.375 2.62288 18.701 3.78486C20.0271 4.94684 20.8807 6.555 21.1 8.30444C21.8074 8.3551 22.4692 8.67232 22.9518 9.19203C23.4344 9.71175 23.7018 10.3952 23.7 11.1044Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2002 18.3047V26.6047",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7002 25.3047V27.2047",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.8999 13.3047V28.2047C4.8999 28.7351 5.11061 29.2438 5.48569 29.6189C5.86076 29.994 6.36947 30.2047 6.8999 30.2047H20.6999C21.2303 30.2047 21.739 29.994 22.1141 29.6189C22.4892 29.2438 22.6999 28.7351 22.6999 28.2047V13.3047",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7002 15.8047H25.8002C26.1715 15.8047 26.5276 15.9522 26.7901 16.2147C27.0527 16.4773 27.2002 16.8334 27.2002 17.2047V23.5047C27.2002 23.876 27.0527 24.2321 26.7901 24.4946C26.5276 24.7572 26.1715 24.9047 25.8002 24.9047H22.7002V15.9047V15.8047Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBeer);
export default __webpack_public_path__ + "static/media/beer.29a70d8626cc6573621f17cdf32b05c7.svg";
export { ForwardRef as ReactComponent };